import {
  Chip,
  Divider,
  List,
  ListItem,
  Typography,
  Drawer,
  Button,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import { useState } from "react";

interface BudgetControlGraphMoreMetricsProps {
  qftd: string;
  qftd_status: string;
  qftd_percentage: string;

  rr_budget_status: string;
  rr_budget_percentage: string;

  remaining_qftd: string;
  cpa_income_dollar: string;
  total_income_dollar: string;
  cpa_budget_dollar: string;
  ftd: string;

  qftd_budget: string | number;
  budget_status: string;
}

const BudgetControlGraphMoreMetrics = ({
  qftd,
  qftd_status,
  qftd_percentage,

  rr_budget_status,
  rr_budget_percentage,

  remaining_qftd,
  cpa_income_dollar,
  total_income_dollar,
  //cpa_budget_dollar,
  ftd,
  qftd_budget,
  //budget_status,
}: BudgetControlGraphMoreMetricsProps) => {
  const [infoOpen, setInfoOpen] = useState(false);
  return (
    <>
      <Stack>
        <List sx={{ pb: 0, color: colors.GrayLightMode[900].$value }}>
          {/* CPA INCOME */}
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              CPA INCOME
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {cpa_income_dollar}
              </Box>
            </Typography>
          </ListItem>
          <Divider />

          {/* CPA BUDGET */}
          {/* <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              CPA BUDGET
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {cpa_budget_dollar}
              </Box>
            </Typography>
          </ListItem> */}
          <Divider />

          {/* RR BUDGET USED */}
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              RR BUDGET USED
              <Chip
                label={rr_budget_percentage}
                size="small"
                sx={{
                  borderRadius: spacing.Radius.xs.$value,
                  fontSize: typography.Size.Text.xs.$value,
                  bgcolor:
                    rr_budget_status === "success"
                      ? colors.Success[50].$value
                      : rr_budget_status === "warning"
                        ? colors.Warning[50].$value
                        : colors.Error[50].$value,
                  color:
                    rr_budget_status === "success"
                      ? colors.Success[600].$value
                      : rr_budget_status === "warning"
                        ? colors.Warning[600].$value
                        : colors.Error[600].$value,
                  fontWeight: typography.Font_weight.Semibold.$value,
                }}
              />
            </Typography>
          </ListItem>
          <Divider />

          {/* QFTD */}
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              QFTD
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                  alignItems: "center",
                }}
              >
                {qftd}
                <Chip
                  label={qftd_percentage}
                  size="small"
                  sx={{
                    borderRadius: spacing.Radius.xs.$value,
                    fontSize: typography.Size.Text.xs.$value,
                    ml: spacing.Spacing.sm.$value,
                    bgcolor:
                      qftd_status === "success"
                        ? colors.Success[50].$value
                        : qftd_status === "warning"
                          ? colors.Warning[50].$value
                          : colors.Error[50].$value,
                    color:
                      qftd_status === "success"
                        ? colors.Success[600].$value
                        : qftd_status === "warning"
                          ? colors.Warning[600].$value
                          : colors.Error[600].$value,
                    fontWeight: typography.Font_weight.Semibold.$value,
                  }}
                />
              </Box>
            </Typography>
          </ListItem>
          <Divider />

          {/* % QFTD BUDGET */}
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                QFTD BUDGET
                <InfoOutlinedIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    setInfoOpen(true);
                  }}
                  sx={{
                    fontSize: 16,
                    color: colors.GrayLightMode[400].$value,
                    cursor: "pointer",
                    ml: 0.5,
                  }}
                />
              </Box>

              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {qftd_budget}
              </Box>
            </Typography>
          </ListItem>
          <Divider />

          {/* REMAINING QFTD */}
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              REMAINING QFTD
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {remaining_qftd}
              </Box>
            </Typography>
          </ListItem>
          <Divider />

          {/* TOTAL INCOME */}
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              TOTAL INCOME
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {total_income_dollar}
              </Box>
            </Typography>
          </ListItem>
          <Divider />

          {/* FTD */}
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                fontWeight: typography.Font_weight.Medium.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              FTD
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.xs.$value,
                }}
              >
                {ftd}
              </Box>
            </Typography>
          </ListItem>
        </List>
      </Stack>

      <Drawer
        anchor="bottom"
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        slotProps={{
          paper: {
            sx: {
              borderTopLeftRadius: spacing.Radius.lg.$value,
              borderTopRightRadius: spacing.Radius.lg.$value,
              p: spacing.Spacing.lg.$value,
            },
          },
        }}
      >
        {/* drag handle */}
        <Box
          sx={{
            width: 40,
            height: 4,
            borderRadius: 2,
            bgcolor: colors.GrayLightMode[300].$value,
            mx: "auto",
            mb: spacing.Spacing.lg.$value,
          }}
        />

        <Typography
          sx={{
            fontSize: typography.Size.Text.lg.$value,
            fontWeight: typography.Font_weight.Semibold.$value,
            color: colors.GrayLightMode[900].$value,
            mb: spacing.Spacing.lg.$value,
          }}
        >
          Data Metrics
        </Typography>

        <Typography
          sx={{
            fontSize: typography.Size.Text.xs.$value,
            fontWeight: typography.Font_weight.Medium.$value,
            color: colors.GrayLightMode[900].$value,
            mb: spacing.Spacing.sm.$value,
          }}
        >
          % QFTD BUDGET
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mb: spacing.Spacing.xl.$value,
          }}
        >
          <LightbulbOutlinedIcon
            sx={{
              fontSize: 16,
              color: colors.GrayLightMode[500].$value,
              mr: 0.5,
            }}
          />
          <Typography
            sx={{
              fontSize: typography.Size.Text.xs.$value,
              fontStyle: "italic",
              color: colors.GrayLightMode[600].$value,
            }}
          >
            Based on the CPA Budget divided by the current deal.
          </Typography>
        </Box>

        <Button
          fullWidth
          variant="contained"
          onClick={() => setInfoOpen(false)}
          sx={{
            bgcolor: colors.Brand[600].$value,
            textTransform: "none",
            fontWeight: typography.Font_weight.Semibold.$value,
            borderRadius: spacing.Radius.md.$value,
            py: 1.25,
            "&:hover": { bgcolor: colors.Brand[700].$value },
          }}
        >
          CLOSE
        </Button>
      </Drawer>
    </>
  );
};

export default BudgetControlGraphMoreMetrics;
